import React from "react";
import Explanation from "./Explanation";
import {WithTranslation, withTranslation} from "react-i18next";

/**
 * Component returning explanations about the geolocation.
 * @author Alizée Grand
 * @version 1.0
 * @creation 20/04/2022
 * @last_update 20/04/2022
 **/
class GeolocationExplanation extends React.Component<WithTranslation> {

    render() {

        return (
            <Explanation>
                {this.props.t("utils.alert.explanation.geolocation")}
            </Explanation>
        );

    };

}

export default withTranslation()(GeolocationExplanation);
